import { render, staticRenderFns } from "./BuyOrders.vue?vue&type=template&id=066f235e&"
import script from "./BuyOrders.vue?vue&type=script&lang=js&"
export * from "./BuyOrders.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports